<template>
  <div class="reportInformation">
    <h2>Informasjon om rapporter</h2>

    <InfoCard class="mt-5 mb-4">
      {{ translate('reports.information.infoCard.text') }}
    </InfoCard>

    <DashboardCard
      v-for="key in Object.keys(informationItems)"
      :key="informationItems[key].title"
      :iconClass="informationItems[key].iconName"
      :heading="informationItems[key].title"
      class="mb-4"
    >
      <div v-for="item in informationItems[key].items" :key="item.title" class="reportInformation__infoBox mb-4">
        <strong>
          {{ item.title }}
        </strong>
        <p>
          {{ item.content }}
        </p>
      </div>
    </DashboardCard>
  </div>
</template>

<script>
import Vue from 'vue';
import DashboardCard from '@/components/DashboardCard';
import InfoCard from '@/components/InfoCard.vue';
import i18nCommon from '@modules/i18n/mixins/Common';

export default Vue.extend({
  name: 'ReportInformation',
  mixins: [i18nCommon],
  components: {
    DashboardCard,
    InfoCard,
  },
  computed: {
    informationItems() {
      return {
        invoice: {
          title: 'Faktura',
          iconName: 'budicon-invoice',
          items: [
            {
              title: 'Fakturaliste',
              content:
                'Fakturalisten viser alle utstedte fakturaer og kreditnotaer i en valgt periode. Rapporten kan avgrenses til et spesifikt bygg. Data vises på skjerm, men kan videre også eksporters i CSV/Excel-format.',
            },
            {
              title: 'Fakturaspesifikasjon',
              content:
                'Rapporten viser alle linjer på utstedte fakturaer i en valgt periode, og kan også avgrenses til spesifikke bygg og status. Data vises på skjerm og kan eksporteres i CSV/Excel-format.',
            },
          ],
        },
        payment: {
          title: 'Betaling',
          iconName: 'budicon-money',
          items: [
            {
              title: 'Betalingsliste',
              content:
                'Betalingslisten viser alle transaksjoner mellom Husleie.no sin klientkonto og utleiers konto/konti i en valgt periode. Rapporten kan avgrenses til et spesifikt bygg. Data vises på skjerm, men kan videre også eksporteres i CSV/Excel-format. For utleiere med behov for overføring av data til eget regnskapssystem vil rapporten understøtte databehovet for kryssing av innbetalinger mot oppføringer i kundereskontro. Rapporten vil således også være et hjelpemiddel for avstemming av poster i bank.',
            },
            {
              title: 'Aldersfordelt kundeliste',
              content:
                'Rapporten viser saldo per kunde med alderssegmentering målt mot forfallsdato per en valgt dato. Rapporten vil være et hjelpemiddel for utleier ved kontroll/avstemming av kundereskontro mellom Husleie.no og eget regnskapssystem. Rapporten gir videre et bilde av risiko i fordringene gjennom alderssegmenteringen.',
            },
          ],
        },
        tenancy: {
          title: 'Leieforhold',
          iconName: 'budicon-apartment-a',
          items: [
            {
              title: 'Depositumskonti',
              content:
                'I denne rapporten har du oversikt over depositumskonto for nåværende og tidligere leietakere. Data vises på skjerm, men kan videre også eksporteres i CSV/Excel-format.',
            },
            {
              title: 'Leieforhold',
              content:
                'Rapporten gir en oversikt over alle nøkkeldata knyttet til nåværende og tidligere leietakere og respektive leieforhold. Data vises på skjerm, men kan videre også eksporteres i CSV/Excel-format.',
            },
            {
              title: 'Leieobjekter',
              content:
                'Rapporten gir en oversikt over alle nøkkeldata knyttet til leieobjekter og nåværende og tidligere leieforhold. Data vises på skjerm, men kan videre også eksporteres i CSV/Excel-format.',
            },
          ],
        },
        download: {
          title: 'Nedlasting',
          iconName: 'budicon-download-queue',
          items: [
            {
              title: 'Fakturaer',
              content:
                'Ved behov kan du laste ned PDF-kopier av fakturaer for en valgt periode. Vær obs på at det kan ta noe tid ettersom det kan være store datamengder som skal genereres.',
            },
          ],
        },
        settings: {
          title: 'Instillinger',
          iconName: 'budicon-cog',
          items: [
            {
              title: 'Leietakere',
              content:
                'På denne siden har du oversikt over nåværende og tidligere leietakere. For hver leietaker har du mulighet til å registerere KundeID som reflekterer tilsvarende dimensjonsverdi i regnskapssystemet. Dette vil forenkle importen av regnskapsdata fra Husleie.no til ditt regnskapssystem.',
            },
            {
              title: 'Leieobjekter',
              content:
                'På denne siden har du oversikt over dine leieobjekter. For hver leieobjekt har du mulighet til å registerere ByggID som reflekterer tilsvarende dimensjonsverdi i regnskapssystemet. Dette vil forenkle importen av regnskapsdata fra Husleie.no til ditt regnskapssystem.',
            },
          ],
        },
      };
    },
  },
});
</script>

<style lang="scss" scoped>
.reportInformation {
  padding: 3rem;
}
.reportInformation__infoBox {
  background: $husleie-ultra-light-grey;
  padding: 1rem;
}
</style>
